import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import AttendeeImg from "../../../res/images/attendee.png";
import AttendeeBadgeImg from "../../../res/images/VIPBadgeTemplate.jpg";
import QRCode from "react-qr-code";

// --- A4 Container ---
const A4Container = styled(Box)(() => ({
  width: "794px",
  height: "1100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
  flexDirection: "column",
  gap: 0,
}));



const CardContainer = styled(Box)(() => ({
  width: "700px",
  height: "970px",
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  flexDirection: "column",
  paddingBottom: 125,
  gap: 65
}));

const StyledTypography = styled(Typography)(() => ({
  fontFamily: '"DIN Pro", Roboto, Helvetica, sans-serif',
  textAlign: "center",
  color: "#fff",
  textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
  fontWeight: "bold",
  fontSize: 50,
}));

const StyledTypographyInvitation = styled(Typography)(() => ({
  fontFamily: '"DIN Pro", Roboto, Helvetica, sans-serif',
  textAlign: "center",
  color: "white",
  fontWeight: "normal",
  fontSize: 30,
}));

const SalutationText = styled(Typography)(() => ({
  fontWeight: "normal",
  textTransform: "capitalize",
  fontSize: 14,
}));
export const StyledBalckTypo = styled(Typography)(({ theme }) => ({
  textShadow:
    "-1px 1px 0 #fff, 1px 1px 0 #fff,1px -1px 0 #fff, -1px -1px 0 #fff",
}));
export const EmptyCard = () => {
  return (
    <A4Container>
      <CardContainer />
    </A4Container>
  );
};

function AttendeeCard({
  jobType,
  attendeeImg,
  salutation,
  name,
  organization,
  bgImg,
  returnBgImage,
  ticket,
  invitation_type,
}) {
  
  return (
    <A4Container>
      <CardContainer
        sx={{
          backgroundImage: !bgImg
            ? `url(${AttendeeBadgeImg})`
            : `url(${returnBgImage(invitation_type)})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Attendee Image */}
          <Box>
            {attendeeImg && <img
              src={attendeeImg}
              alt="Attendee"
              style={{
                width: 450,
                height: 206,
                marginTop: 35,
                objectFit: "contain",
              }}
            />}
          </Box>

          {/* Info */}
          <Box sx={{ textAlign: "center", maxWidth: 600, mx: "auto" }}>
       <StyledTypography
  fontWeight={700}

  fontFamily="Roboto, sans-serif" 
  textTransform="uppercase"
  sx={{
    fontSize:"45px",
    mt: 7,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
    flexWrap: "wrap",
  }}
>
              <SalutationText></SalutationText>
              {salutation}  {name || ""}
            </StyledTypography>


            {jobType ? <StyledTypography fontWeight={400} sx={{fontSize:"30px"}} textTransform="uppercase">
              {jobType || ""}
            </StyledTypography>
              : <Box sx={{ height: 0 }}></Box>}
            <Box sx={{ mt: 0 }}>
              <StyledTypographyInvitation fontWeight={600} fontSize={20} textTransform="uppercase" >

                {organization || ""}
              </StyledTypographyInvitation>
            </Box>
          </Box>

        </Box>
        {/* QR Code */}
        {ticket && (
          <QRCode
            size={252}
            style={{
              height: "auto",
              maxWidth: "90%",
              width: "190px",
              backgroundColor: "#fff",
              padding: 10,
              border: "1px solid #000",
              // marginRight: "20px",
            }}
            value={ticket}
            viewBox={`0 0 256 256`}
          />
        )}
      </CardContainer>
    </A4Container>
  );
}

export default AttendeeCard;